import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-page05',
  templateUrl: './blog-page05.component.html',
  styleUrls: ['./blog-page05.component.css']
})
export class BlogPage05Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
